import { render, staticRenderFns } from "./Aprovacao.vue?vue&type=template&id=3e536790&"
import script from "./Aprovacao.vue?vue&type=script&lang=js&"
export * from "./Aprovacao.vue?vue&type=script&lang=js&"
import style0 from "./Aprovacao.vue?vue&type=style&index=0&id=3e536790&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports